import TheGrid from '@/views/siteregistrations/grid'
import Edit from '@/views/siteregistrations/edit'

export default {
  path: '/siteregistrations',
  redirect: '/siteregistrations/index',
  name: 'siteregistrations',
  meta: {
    auth: {
      redirect: {
        name: 'siteregistrations.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Formulários do Site'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'siteregistrations.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'siteregistrations.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'siteregistrations.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
